import { reactive } from "vue";

export const eventBus = reactive({
  listeners: {},
  
  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  },
  
  emit(event, payload) {
    if (this.listeners[event]) {
      this.listeners[event].forEach((callback) => callback(payload));
    }
  },

  // Add this new method to remove listeners
  off(event, callback) {
    if (this.listeners[event]) {
      // Remove specific callback
      if (callback) {
        this.listeners[event] = this.listeners[event].filter(
          (cb) => cb !== callback
        );
      } 
      // Or remove all callbacks for this event if no callback provided
      else {
        this.listeners[event] = [];
      }
    }
  }
});
